var _style, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxalisSiteWebBoutonsOpenBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.3 28.3",
    style: {
      enableBackground: "new 0 0 28.3 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#914E72;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.8,3.9 12.8,12.7 3.9,12.7 3.9,15.5 12.8,15.5 12.8,24.4 15.6,24.4 15.6,15.5 24.4,15.5 24.4,12.7  15.6,12.7 15.6,3.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxalisSiteWebBoutonsOpenBlanc);
export default __webpack_public_path__ + "static/media/OXALIS_site_web_boutons_open_blanc.7610bf0fa169f9b98f67211cffeaf709.svg";
export { ForwardRef as ReactComponent };